/**
 * Portal Manta · CapaPage
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';
import { LotePage } from './LotePage.jsx';
import { SumarioOficialPage } from './SumarioOficialPage.jsx';
import { ConhecimentoConsolidadoPage } from './ConhecimentoConsolidadoPage.jsx';
import { NovoEstudoFluxoPage } from '../novo-estudo/NovoEstudoFluxoPage.jsx';
import { AdicionarBasePage } from './AdicionarBasePage.jsx';
import { RelatoriosStandalonePage } from '../relatorios/RelatoriosStandalonePage.jsx';
import { CriterioSimilaridadePage } from './CriterioSimilaridadePage.jsx';
import { AgentesCatalogoPage } from './AgentesCatalogoPage.jsx';
import { AluciGuardPlaceholderPage } from '../aluci-guard/AluciGuardPage.jsx';
import { AjudaPage } from './AjudaPage.jsx';
import { TourPanelM } from '../sidebar/TourPanelM.jsx';
import { LOTES_INFO } from '../../globals.js';
import { TOUR_M } from '../../data/capitulos.js';
import { AluciGuardPage } from '../aluci-guard/AluciGuardPage2.jsx';

const CapaPage = memo(function CapaPage_Inner({onSelectLote}){
  const [secCapa,setSecCapa]=useState('sumario'); // v22.1: sumário + abas verticais
  const [sidebarColl,setSidebarColl]=useState(false); // v22.2: sidebar colapsável
  const [tourStep,setTourStep]=useState(0); // v24: TourPanel · padrão dual Manta
  const [tourOpen,setTourOpen]=useState(true); // v24: toggle visibilidade do tour
  // Sincronizar tour com seção ativa
  useEffect(()=>{
    const idx = TOUR_M.findIndex(p => {
      if (p.id==='sumario'      && secCapa==='sumario')      return true;
      if (p.id==='lote-3'       && secCapa==='lote3')        return true;
      if (p.id==='lote-4'       && secCapa==='lote4')        return true;
      if (p.id==='lote-5'       && secCapa==='lote5')        return true;
      if (p.id==='conhecimento' && secCapa==='conhecimento') return true;
      if (p.id==='novo-estudo'  && secCapa==='novo')         return true;
      if (p.id==='add-base'     && secCapa==='addbase')      return true;
      if (p.id==='aluci-guard'  && secCapa==='aluci')        return true;
      if (p.id==='criterio'     && secCapa==='similar')      return true;
      if (p.id==='agentes'      && secCapa==='agentes')      return true;
      if (p.id==='ajuda'        && secCapa==='ajuda')        return true;
      return false;
    });
    if (idx >= 0) setTourStep(idx);
  }, [secCapa]);
  // tourStep → secCapa
  const scrollFromTour = (id) => {
    const map = {'sumario':'sumario','lote-3':'lote3','lote-4':'lote4','lote-5':'lote5','conhecimento':'conhecimento','novo-estudo':'novo','add-base':'addbase','aluci-guard':'aluci','criterio':'similar','agentes':'agentes','ajuda':'ajuda'};
    if (map[id]) setSecCapa(map[id]);
  };
  const lotes=[
    {k:'3',cor:'#D4682A',corBg:'#fff7ed',corBorder:'#D4682A',sigla:'L3',nome:'Paraná · Lote 3',ext:'569,8 km',capex:'R$ 9,90 bi',opex:'R$ 4,56 bi',tir:'10,64%',prazo:'30 anos',oae:'184 un',uf:'PR',fase:'FEL-1',rodovias:7,duplicacao:'132,6 km'},
    {k:'4',cor:'#1d4ed8',corBg:'#eff6ff',corBorder:'#1d4ed8',sigla:'L4',nome:'Paraná · Lote 4',ext:'627,5 km',capex:'R$ 14,20 bi',opex:'R$ 5,80 bi',tir:'10,21%',prazo:'30 anos',oae:'160 un',uf:'PR',fase:'FEL-1',rodovias:11,duplicacao:'232,0 km'},
    {k:'5',cor:'#16a34a',corBg:'#f0fdf4',corBorder:'#16a34a',sigla:'L5',nome:'Paraná · Lote 5',ext:'432,8 km',capex:'R$ 8,10 bi',opex:'R$ 3,20 bi',tir:'9,85%',prazo:'30 anos',oae:'66 un',uf:'PR',fase:'FEL-1',rodovias:9,duplicacao:'238,6 km'},
  ];
  return(
    <div style={{flex:1,overflowY:'auto',background:'#F4F6FA'}}>

      {/* HERO BANNER — imagem arredondada com margem lateral */}
      <div style={{padding:'24px 32px 0'}}>
        <div style={{position:'relative',borderRadius:20,overflow:'hidden',boxShadow:'0 8px 40px rgba(0,0,0,.28)'}}>
          <img src={(typeof window!=='undefined' && window.MANTA_HERO_IMAGE) || "data:image/svg+xml;utf8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%201600%20480'%20preserveAspectRatio%3D'xMidYMid%20slice'%3E%3Cdefs%3E%3ClinearGradient%20id%3D'g'%20x1%3D'0'%20y1%3D'0'%20x2%3D'1'%20y2%3D'1'%3E%3Cstop%20offset%3D'0%25'%20stop-color%3D'%230D1526'%2F%3E%3Cstop%20offset%3D'40%25'%20stop-color%3D'%231E2A4A'%2F%3E%3Cstop%20offset%3D'100%25'%20stop-color%3D'%232D3F6B'%2F%3E%3C%2FlinearGradient%3E%3CradialGradient%20id%3D'glow'%20cx%3D'25%25'%20cy%3D'40%25'%20r%3D'60%25'%3E%3Cstop%20offset%3D'0%25'%20stop-color%3D'%236C63FF'%20stop-opacity%3D'.35'%2F%3E%3Cstop%20offset%3D'100%25'%20stop-color%3D'%236C63FF'%20stop-opacity%3D'0'%2F%3E%3C%2FradialGradient%3E%3Cpattern%20id%3D'grid'%20width%3D'80'%20height%3D'80'%20patternUnits%3D'userSpaceOnUse'%3E%3Cpath%20d%3D'M80%200H0V80'%20fill%3D'none'%20stroke%3D'%23ffffff'%20stroke-opacity%3D'.04'%2F%3E%3C%2Fpattern%3E%3C%2Fdefs%3E%3Crect%20width%3D'1600'%20height%3D'480'%20fill%3D'url(%23g)'%2F%3E%3Crect%20width%3D'1600'%20height%3D'480'%20fill%3D'url(%23grid)'%2F%3E%3Crect%20width%3D'1600'%20height%3D'480'%20fill%3D'url(%23glow)'%2F%3E%3C%2Fsvg%3E"} alt="hero" style={{width:'100%',height:340,objectFit:'cover',objectPosition:'center 40%',display:'block'}}/>
          <div style={{position:'absolute',inset:0,background:'linear-gradient(90deg,rgba(10,16,30,.52) 0%,rgba(10,16,30,.22) 30%,rgba(0,0,0,0) 55%,rgba(0,0,0,0) 100%)'}} />
          {/* Logo Motiva — SVG oficial do site motiva.com.br */}
          <div style={{position:'absolute',top:22,left:'50%',transform:'translateX(-50%)',display:'flex',alignItems:'center',whiteSpace:'nowrap'}}>
            <svg width="160" height="32" viewBox="0 0 160 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M37.5196 18.8391C34.1558 22.2567 36.0774 26.0881 33.2459 28.9655C32.0378 30.1954 30.3049 31.1111 28.3379 31.1111V16.7088C30.0029 16.7088 31.7056 16.2222 33.3252 14.5747C36.689 11.1571 34.7674 7.3295 37.5989 4.44828C38.8108 3.21839 40.5852 2.31801 42.5069 2.30269V16.705C40.8268 16.705 39.1393 17.1916 37.5196 18.8391Z" fill="white"/>
              <path d="M23.3507 18.8391C19.9868 22.2567 21.9085 26.0881 19.0769 28.9655C17.8688 30.1954 16.1359 31.1111 14.169 31.1111V16.7088C15.8339 16.7088 17.5366 16.2222 19.1562 14.5747C22.5201 11.1571 20.5984 7.3295 23.4299 4.44828C24.6418 3.21839 26.4163 2.31801 28.3379 2.30269V16.705C26.6579 16.705 24.9703 17.1916 23.3507 18.8391Z" fill="white"/>
              <path d="M9.18169 18.8391C5.81784 22.2567 7.7395 26.0881 4.90798 28.9655C3.69986 30.1954 1.92166 31.0996 0 31.1111V16.7088C1.66494 16.7088 3.36763 16.2222 4.98726 14.5747C8.35111 11.1571 6.42945 7.3295 9.26097 4.44828C10.4729 3.21839 12.2473 2.31801 14.169 2.30269V16.705C12.4889 16.705 10.8013 17.1916 9.18169 18.8391Z" fill="white"/>
              <path d="M98.1821 9.49427C96.3586 7.72032 93.95 6.81994 91.024 6.81994C88.0981 6.81994 85.9764 7.72415 84.1529 9.57856C82.3294 11.433 81.4044 13.8161 81.4044 16.659C81.4044 22.659 85.2628 26.5364 91.2317 26.5364C93.9651 26.5364 96.2794 25.5939 98.1029 23.7395C99.9264 21.8851 100.851 19.5019 100.851 16.659C100.851 13.8161 99.9641 11.2874 98.2086 9.52492L98.1784 9.49427H98.1821ZM95.6111 16.6628C95.6111 20.1609 93.9424 22.2529 91.1524 22.2529C88.3624 22.2529 86.6522 20.2682 86.6522 16.6628C86.6522 13.0575 88.336 11.1111 91.1524 11.1111C94.8372 11.1111 95.6111 14.1303 95.6111 16.6628Z" fill="white"/>
              <path d="M122.552 7.1073H117.606V26.3142H122.552V7.1073Z" fill="white"/>
              <path d="M144.06 7.1073H138.265L134.237 20.6782H133.976L129.982 7.1073H124.187L131.504 26.3104H136.532L144.06 7.1073Z" fill="white"/>
              <path d="M73.2194 6.64371C70.958 6.64371 68.9948 7.67053 67.3865 9.69735H67.3525C66.2954 7.75482 64.3473 6.64371 61.9877 6.64371C60.0207 6.64371 58.4464 7.59007 56.8419 9.48279H56.6871L56.6191 7.10731H51.9566V26.3142H57.0042V13.0613C58.1444 11.9847 59.3563 11.4598 60.7154 11.4598C62.286 11.4598 63.1505 12.5709 63.1505 14.5824V26.3142H68.2397V13.5096C68.2397 13.2491 68.2397 13.0345 68.2284 12.8506C69.2968 11.9272 70.5502 11.4598 71.9509 11.4598C73.5215 11.4598 74.386 12.5709 74.386 14.5824V26.3142H79.4337V13.5096C79.4337 8.77015 76.3152 6.64754 73.227 6.64754L73.2194 6.64371Z" fill="white"/>
              <path d="M104.638 2.30269V4.90039C104.638 6.81993 103.664 7.10345 102.467 7.10345H101.27V11.4138H104.642V19.7663C104.642 23.9234 106.911 26.3103 110.864 26.3103H114.548V21.4981H111.026C110.124 21.4981 109.591 21.0383 109.591 20.0421V11.4176H115.485V7.10728H109.591V2.30269H104.638Z" fill="white"/>
              <path d="M120.083 5.54789C121.593 5.54789 122.816 4.30595 122.816 2.77395C122.816 1.24194 121.593 0 120.083 0C118.573 0 117.35 1.24194 117.35 2.77395C117.35 4.30595 118.573 5.54789 120.083 5.54789Z" fill="white"/>
              <path d="M157.859 8.52486C156.576 7.5172 154.718 7.04594 152.011 7.04594C147.402 7.04594 144.706 9.04593 144.004 12.9846L143.951 13.272L148.255 13.954L148.319 13.6781C148.738 11.8199 149.965 10.8812 151.966 10.8812C153.291 10.8812 155.073 11.2528 155.073 13.0191V14.0076L149.961 15.1839C145.555 16.2605 143.128 18.2605 143.128 21.1187C143.128 24.5095 146.59 26.5402 149.236 26.5402C149.437 26.5402 149.516 26.5478 149.712 26.5478C152.196 26.5478 153.635 25.6015 155.134 24.0613H155.402V26.318H159.974L160 14.1379C160 11.498 159.298 9.66663 157.852 8.52869L157.859 8.52486ZM155.164 17.3831V20.2873L154.567 20.7739C153.284 21.7777 151.947 22.5287 150.048 22.4214C148.689 22.3448 148.27 21.6053 148.202 21.0804C148.077 20.1226 148.832 19.1341 151.192 18.4559L155.168 17.3869L155.164 17.3831Z" fill="white"/>
            </svg>
          </div>
          {/* Texto hero */}
          <div style={{position:'absolute',bottom:0,left:0,right:0,padding:'28px 44px 36px'}}>
            <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:12}}>
              <div style={{width:4,height:44,background:'#6C63FF',borderRadius:2}}/>
              <div>
                <div style={{fontSize:40,fontWeight:800,color:'#fff',lineHeight:1.1,textShadow:'0 2px 12px rgba(0,0,0,.4)'}}>Portal de<br/>Orçamentação</div>
              </div>
            </div>
            <div style={{fontSize:14,color:'rgba(255,255,255,.8)',maxWidth:500,lineHeight:1.6,marginLeft:14}}>Plataforma integrada de <span style={{color:'#a78bfa',fontWeight:600}}>inteligência paramétrica</span> para engenharia de rodovias · ANTT · PR</div>
            <div style={{marginLeft:14,marginTop:14,display:'inline-block',padding:'4px 14px',background:'rgba(255,255,255,.12)',border:'1px solid rgba(255,255,255,.2)',borderRadius:20,fontSize:9,fontWeight:700,color:'rgba(255,255,255,.8)',letterSpacing:'.1em'}}>ELABORAÇÃO TÉCNICA · MANTA ASSOCIADOS</div>
          </div>
        </div>
      </div>

      {/* ========================================================== */}
      {/* v22.1 · ÍNDICE COM SUMÁRIO + ABAS VERTICAIS                  */}
      {/* ========================================================== */}
      <div style={{padding:'24px 32px 40px',display:'flex',gap:24,alignItems:'flex-start'}}>

        {/* SIDEBAR VERTICAL DE ABAS (v22.2 · colapsável + numerada 1–9) */}
        <div style={{width:sidebarColl?64:240,flexShrink:0,background:'#1A2840',borderRadius:14,padding:'14px 0 8px',position:'sticky',top:24,boxShadow:'0 4px 16px rgba(0,0,0,.08)',transition:'width .22s ease'}}>

          {/* HEADER + TOGGLE */}
          <div style={{padding:sidebarColl?'0 0 12px':'0 18px 12px',borderBottom:'1px solid rgba(255,255,255,.08)',display:'flex',alignItems:'center',justifyContent:sidebarColl?'center':'space-between',gap:8}}>
            {!sidebarColl && (
              <div>
                <div style={{fontSize:9,fontWeight:700,color:'#F4A76A',letterSpacing:'.12em',textTransform:'uppercase',marginBottom:2}}>Portal Manta</div>
                <div style={{fontSize:12,fontWeight:700,color:'#fff'}}>Índice geral</div>
              </div>
            )}
            <button onClick={()=>setSidebarColl(!sidebarColl)}
              title={sidebarColl?'Expandir':'Colapsar'}
              style={{width:30,height:30,borderRadius:8,background:'rgba(255,255,255,.08)',border:'1px solid rgba(255,255,255,.12)',color:'#fff',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontFamily:'inherit',transition:'all .15s'}}
              onMouseEnter={e=>{e.currentTarget.style.background='#F4A76A';e.currentTarget.style.color='#1A2840';e.currentTarget.style.borderColor='#F4A76A';}}
              onMouseLeave={e=>{e.currentTarget.style.background='rgba(255,255,255,.08)';e.currentTarget.style.color='#fff';e.currentTarget.style.borderColor='rgba(255,255,255,.12)';}}>\n              {sidebarColl?'»':'«'}
            </button>
          </div>

          {[
            {grupo:'⓪ INÍCIO',itens:[
              {k:'sumario',  n:'00', tx:'Sumário'},
            ]},
            {grupo:'I · EXPLORAR',itens:[
              {k:'lote3',       n:'01', tx:'Lote 3 · BR-376'},
              {k:'lote4',       n:'02', tx:'Lote 4 · PR-323'},
              {k:'lote5',       n:'03', tx:'Lote 5 · BR-369'},
              {k:'conhecimento',n:'04', tx:'Conhecimento Consolidado'},
            ]},
            {grupo:'II · CRIAR',itens:[
              {k:'novo',       n:'05', tx:'Novo Estudo'},
              {k:'addbase',    n:'06', tx:'Adicionar à Base'},
              {k:'relatorios', n:'07', tx:'📊 Relatórios'},
            ]},
            {grupo:'III · CONFIGURAR',itens:[
              {k:'similar',    n:'08', tx:'Critério de Similaridade'},
              {k:'agentes',    n:'09', tx:'Catálogo de Agentes'},
            ]},
            {grupo:'IV · AJUDA',itens:[
              {k:'ajuda',      n:'10', tx:'Tour & Glossário'},
            ]},
          ].map(g=>(
            <div key={g.grupo} style={{padding:'12px 0 4px'}}>
              {!sidebarColl && (
                <div style={{padding:'0 18px 6px',fontSize:8,fontWeight:700,color:'rgba(255,255,255,.4)',letterSpacing:'.14em'}}>{g.grupo}</div>
              )}
              {sidebarColl && (
                <div style={{height:1,background:'rgba(255,255,255,.06)',margin:'0 14px 4px'}}/>
              )}
              {g.itens.map(it=>{
                const at = secCapa===it.k;
                const isLote = it.k.startsWith('lote');
                return (
                  <div key={it.k}
                    title={sidebarColl?(it.n+' · '+it.tx):''}
                    onClick={()=>{ if(isLote){ onSelectLote(it.k.slice(4)); } else { setSecCapa(it.k); } }}
                    style={{padding:sidebarColl?'7px 0':'8px 18px',display:'flex',alignItems:'center',gap:10,cursor:'pointer',justifyContent:sidebarColl?'center':'flex-start',
                      background:at?'rgba(244,167,106,.14)':'transparent',
                      borderLeft:at && !sidebarColl?'3px solid #F4A76A':'3px solid transparent',
                      transition:'all .12s'}}
                    onMouseEnter={e=>{if(!at)e.currentTarget.style.background='rgba(255,255,255,.04)';}}
                    onMouseLeave={e=>{if(!at)e.currentTarget.style.background='transparent';}}>
                    <div style={{width:26,height:26,borderRadius:7,background:at?'#F4A76A':'rgba(255,255,255,.08)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,boxShadow:at?'0 2px 6px rgba(244,167,106,.4)':'none'}}>
                      <span style={{fontSize:11,fontWeight:800,color:at?'#1A2840':'rgba(255,255,255,.7)',letterSpacing:'-.5px'}}>{it.n}</span>
                    </div>
                    {!sidebarColl && (
                      <span style={{fontSize:11.5,fontWeight:at?700:500,color:at?'#fff':'rgba(255,255,255,.75)'}}>{it.tx}</span>
                    )}
                  </div>
                );
              })}
            </div>
          ))}

          {!sidebarColl && (
            <div style={{padding:'12px 18px 4px',marginTop:6,borderTop:'1px solid rgba(255,255,255,.08)'}}>
              <div style={{fontSize:9,color:'rgba(255,255,255,.5)',lineHeight:1.5}}>Manta Associados<br/><span style={{color:'rgba(255,255,255,.3)'}}>FEL-1 · ANTT · Paraná</span></div>
            </div>
          )}
        </div>

        {/* ÁREA DE CONTEÚDO DINÂMICA */}
        <div style={{flex:1,minWidth:0}}>

          {/* ====== SUMÁRIO (default) ====== */}
          {secCapa==='sumario' && (
            <div style={{flex:1,overflow:'auto',background:'#fff'}}>
              <SumarioOficialPage/>
            </div>
          )}

          {/* I · EXPLORAR */}
          {secCapa==='lote3'        && <LotePage loteKey="3"/>}
          {secCapa==='lote4'        && <LotePage loteKey="4"/>}
          {secCapa==='lote5'        && <LotePage loteKey="5"/>}
          {secCapa==='conhecimento' && (
            <div style={{flex:1,overflow:'auto',background:'#fff',borderRadius:14,border:'1px solid #E5E7EB'}}>
              <ConhecimentoConsolidadoPage/>
            </div>
          )}

          {/* II · CRIAR */}
          {secCapa==='novo' && (
            <div style={{flex:1,overflow:'auto',background:'#fff',borderRadius:14,border:'1px solid #E5E7EB'}}>
              <NovoEstudoFluxoPage/>
            </div>
          )}
          {secCapa==='addbase' && (
            <div style={{flex:1,overflow:'auto',background:'#fff',borderRadius:14,border:'1px solid #E5E7EB'}}>
              <AdicionarBasePage/>
            </div>
          )}
          {secCapa==='relatorios' && (
            <div style={{flex:1,overflow:'auto',background:'#fff',borderRadius:14,border:'1px solid #E5E7EB'}}>
              <RelatoriosStandalonePage/>
            </div>
          )}

          {/* III · CONFIGURAR */}
          {secCapa==='similar' && (
            <div style={{flex:1,overflow:'auto',background:'#fff',borderRadius:14,border:'1px solid #E5E7EB'}}>
              <CriterioSimilaridadePage/>
            </div>
          )}
          {secCapa==='agentes' && (
            <div style={{flex:1,overflow:'auto',background:'#fff',borderRadius:14,border:'1px solid #E5E7EB'}}>
              <AgentesCatalogoPage/>
            </div>
          )}

          {/* II · ALUCI-GUARD · v28.12 */}
          {secCapa==='aluci' && (
            <div style={{flex:1,overflow:'auto',background:'#fff',borderRadius:14,border:'1px solid #E5E7EB'}}>
              <AluciGuardPlaceholderPage/>
            </div>
          )}

          {/* IV · AJUDA */}
          {secCapa==='ajuda' && (
            <div style={{flex:1,overflow:'auto',background:'#fff',borderRadius:14,border:'1px solid #E5E7EB'}}>
              <AjudaPage/>
            </div>
          )}

        </div>

        {/* ═══ Tour Panel (Padrão 12.5 · obrigatório) ═══ */}
        {tourOpen && (
          <TourPanelM tourStep={tourStep} setTourStep={setTourStep} scrollTo={scrollFromTour}/>
        )}
        {/* Botão toggle Tour */}
        <button onClick={()=>setTourOpen(!tourOpen)} title={tourOpen?'Esconder tour':'Mostrar tour'} style={{position:'fixed', right:tourOpen?280:8, top:20, zIndex:100, width:34, height:34, borderRadius:'50%', background:M.accent, color:'#fff', border:'none', fontSize:16, cursor:'pointer', boxShadow:'0 4px 12px rgba(0,0,0,.18)', transition:'right .2s'}}>
          {tourOpen?'›':'🧭'}
        </button>
      </div>
    </div>
  );
});

export { CapaPage };
export default CapaPage;
